<template>
  <table-layout title="سطل زباله محصولات" :showSearch="false">
    <template #buttons>

      <router-link :to="{ name: 'ProductsDashboard' }" class="ml-2">
        <b-button pill variant="purple"> بازگشت به صفحه محصولات</b-button>
      </router-link>
    </template>
    <template #table>
      <tabel-items :items="TrashProducts" :restoreState="true"/>
      <b-row class="pt-3 mt-3">
        <pagination :meta="paginationMeta" :on-change-page="changePage"/>
      </b-row>
    </template>
  </table-layout>
</template>

<script>
import TableLayout from "../TableLayout.vue";
import tabelItems from "../product/tableItems.vue";
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import {mapGetters} from "vuex";
import Pagination from "../Pagination.vue";

export default {
  name: "trashItems",
  components: {TableLayout, tabelItems, Pagination},
  data() {
    return {
      tableAttributes,
    };
  },
  methods: {
    changePage(page) {
      this.$store.dispatch("Product/getTrash", page);
    },
  },
  computed: {
    ...mapGetters({
      'TrashProducts': "Product/getTrash",
      paginationMeta: "Product/getPaginationMeta",
    }),
  },
  mounted() {
    this.$store.dispatch("Product/getTrash")
  }
};
</script>